import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Modal,
  Image,
} from "react-native";
import { AppColors } from "../../../../utility/AppColors";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppImages } from "../../../../utility/AppImages";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import Separator from "../../../../Components/Separator";
import { ScrollView } from "react-native-gesture-handler";
import ImageComponent from "../../../../Components/ImageComponent";
import { useChat } from "../../../../context/ChatContext";
import { CropImage } from "../../../../Components/choose-avatar-components/CropImage";
import { formatDistanceToNow } from "date-fns";
import {
  CommonActions,
  StackActions,
  useNavigation,
} from "@react-navigation/native";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import { AppScreens } from "../../../Utility/AppScreens";
import Avatar from "../../../../Components/choose-avatar-components/Avatar";
import AsyncStorage from "@react-native-async-storage/async-storage";
import MessagePopupSkeleton from "../../../../Components/skeleton-components/MessagePopupSkeleton";
const MessagePopup = ({
  isVisible,
  onClose,
  position,
}: {
  isVisible: boolean;
  onClose: () => void;
  position: { x: number; y: number; width: number; height: number };
}) => {
  if (!isVisible) return null;
  const navigation = useNavigation();
  const deviceSize = useDeviceSize();
  const styles = useStyles();
  const [activeTab, setActiveTab] = useState("All");
  const [messages, setMessages] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [hasFetchedBefore, setHasFetchedBefore] = useState(null); // null = checking, false = never fetched, true = fetched before
  const { fetchUserChats, chats, userData } = useChat();

  useEffect(() => {
    const loadCachedAndCheckStatus = async () => {
      try {
        const isWeb = typeof window !== "undefined" && window.sessionStorage;
        let hasFetchedThisSession = false;

        if (isWeb) {
          hasFetchedThisSession =
            sessionStorage.getItem("hasFetchedMessages") === "true";
        } else {
          hasFetchedThisSession = global.hasFetchedMessages === true;
        }

        setHasFetchedBefore(hasFetchedThisSession);

        const cachedMessages = await AsyncStorage.getItem("cachedMessages");
        if (cachedMessages && hasFetchedThisSession) {
          try {
            const parsed = JSON.parse(cachedMessages);
            const validMessages = parsed.filter(
              (message) => message !== null && message !== undefined
            );
            if (validMessages.length > 0) {
              setMessages(validMessages);
            }
          } catch (parseError) {
            console.warn("Failed to parse cached messages:", parseError);
          }
        }
      } catch (error) {
        console.warn("Failed to load cached data:", error);
        setHasFetchedBefore(false);
      }
    };

    loadCachedAndCheckStatus();
  }, []);

  useEffect(() => {
    if (hasFetchedBefore === null) {
      return;
    }

    if (isVisible && !hasFetchedBefore) {
      // First time - show skeleton
      setShowLoader(true);
      const messagePopup = true;
      fetchUserChats(null, messagePopup);
    } else if (isVisible && hasFetchedBefore) {
      // Already fetched - no skeleton, just fetch in background
      const messagePopup = true;
      fetchUserChats(null, messagePopup);
    }
  }, [isVisible, hasFetchedBefore]);
  const removeMessage = (id) => {
    setMessages((prevMessages) =>
      prevMessages.filter((message) => message?.conversationId !== id)
    );
  };
  const [filteredMessages, setFilteredMessages] = useState([]);
  useEffect(() => {
    if (chats.length > 0 && userData?.username) {
      const filteredChats = chats.filter(
        (chat) => chat.unreadCount > 0
      );
      const newMessages = filteredChats
        .sort((a, b) => b.lastMessageTimestamp - a.lastMessageTimestamp) // Sorting in descending order
        .slice(0, 6);

      setMessages(newMessages);

      // Hide skeleton and mark as fetched after first load
      if (showLoader) {
        setShowLoader(false);
        setHasFetchedBefore(true);

        const isWeb = typeof window !== "undefined" && window.sessionStorage;
        if (isWeb) {
          sessionStorage.setItem("hasFetchedMessages", "true");
        } else {
          global.hasFetchedMessages = true;
        }
      }

      // Cache the messages
      try {
        AsyncStorage.setItem("cachedMessages", JSON.stringify(newMessages));
      } catch (cacheError) {
        console.warn("Failed to cache messages:", cacheError);
      }
    }
  }, [chats, userData]);
  useEffect(() => {
    let updatedMessages = [];

    if (activeTab === "All") {
      updatedMessages = messages;
    } else if (activeTab === "KO Chat") {
      updatedMessages = messages.filter(
        (chat) => chat.type === "group" || chat.type === "single"
      );
    } else {
      updatedMessages = messages.filter((chat) => chat.type === "event");
    }

    setFilteredMessages(updatedMessages);
  }, [activeTab, messages]);
  const getRelativeTime = (timestamp: number) => {
    if (!timestamp || typeof timestamp !== 'number') {
      return "Unknown time";
    }
    
    try {
      const date = new Date(timestamp); 
      
      if (isNaN(date.getTime())) {
        console.warn("Invalid timestamp:", timestamp);
        return "Invalid date";
      }
      
      return formatDistanceToNow(date, { addSuffix: true });
    } catch (error) {
      console.error("Error formatting timestamp:", error, "timestamp:", timestamp);
      return "Unknown time";
    }
  };
  return (
    <Modal transparent={true} visible={isVisible} onRequestClose={onClose}>
      <View style={styles.modalOverlay}>
        <TouchableOpacity style={styles.overlayBackground} onPress={onClose} />
        <View
          style={[
            styles.modalContent,
            {
              position: "absolute",
              top: position.y + 10,
              ...(deviceSize === DEVICE_SIZES.XS ||
              deviceSize === DEVICE_SIZES.SM
                ? {}
                : { left: position.x - 430 }),
              width:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "100%"
                  : 449,
            },
          ]}
        >
          {showLoader ? (
            <MessagePopupSkeleton deviceSize={deviceSize} />
          ) : (
            <>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Text style={AppFontStyle.MEDIUM_ANYBODY_18}>Messages</Text>
            <TouchableOpacity
              style={{
                justifyContent: "center",
                alignItems: "center",
              }}
              onPress={() => {
                onClose();
              }}
            >
              <Image
                source={AppImages.icCloseWhite}
                style={{
                  height:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? 20
                      : 25,
                  width:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? 20
                      : 25,
                }}
              />
            </TouchableOpacity>
          </View>
          <Separator
            color={'#374151'}
            height={1}
            marginTop={12}
            marginBottom={12}
            marginHorizontal={0}
          />
          <View style={styles.tabContainer}>
            {["All", "KO Chat", "Event Chat"].map((tab) => (
              <TouchableOpacity
                key={tab}
                onPress={() => setActiveTab(tab)}
                style={[
                  styles.tab,
                  activeTab === tab ? styles.activeTab : styles.inactiveTab,
                ]}
              >
                <Text
                  style={[
                    AppFontStyle.MEDIUM_ANYBODY_14,
                    activeTab === tab
                      ? styles.activeTabText
                      : styles.inactiveTabText,
                  ]}
                >
                  {tab} (
                  {tab === "All"
                    ? messages.length
                    : tab === "KO Chat"
                    ? messages.filter(
                        (msg) => msg.type === "group" || msg.type === "single"
                      ).length
                    : messages.filter((msg) => msg.type === "event").length}
                  )
                </Text>
              </TouchableOpacity>
            ))}
          </View>
          <Separator
            color={'#374151'}
            height={1}
            marginTop={12}
            marginBottom={12}
            marginHorizontal={0}
          />
          <View>
            {filteredMessages.length > 0 ? (
              filteredMessages.map((message) => (
                <View
                  key={message?.conversationId}
                  style={{
                    position: "relative",
                  }}
                >
                  {/* Left border indicator for unread messages */}
                  {message.lastMessageUser !== userData?.username && (
                    <View
                      style={{
                        position: "absolute",
                        left: 0,
                        top: 0,
                        bottom: 25,
                        width: 4,
                        backgroundColor: '#DC2626',
                        borderRadius: 2,
                      }}
                    />
                  )}
                  {/* Unread count badge at bottom-right corner */}
                  {message.unreadCount > 0 && (
                    <View
                      style={{
                        position: "absolute",
                        right: 12,
                        bottom: 20,
                        backgroundColor: '#DC2626',
                        borderRadius: 8,
                        height: 16,
                        minWidth: 16,
                        paddingHorizontal: 4,
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 10,
                      }}
                    >
                      <Text
                        style={{
                          color: AppColors.white,
                          fontSize: 10,
                          fontWeight: "bold",
                          lineHeight: 12,
                        }}
                      >
                        {message.unreadCount}
                      </Text>
                    </View>
                  )}
                  <TouchableOpacity
                    onPress={() => {
                      if (message.type === "event") {
                        navigateToScreen(navigation, AppScreens.OnGoingEvents, {
                            eventID: message.eventID,
                          });
                      } else {
                        navigation.dispatch(
                          CommonActions.reset({
                            index: 0,
                            routes: [{ name: "ChatTabStack" }],
                          })
                        );
                      }

                      onClose();
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        paddingLeft: 12,
                      }}
                    >
                      {message.type === "single" ? (
                        <Avatar
                          src={message?.profilePicture}
                          variant="notificationSmallPlayer"
                        />
                      ) : (
                        <View
                          style={{
                            marginLeft: 16,
                            marginRight: 20,
                          }}
                        >
                          <ImageComponent
                            url={message?.profilePicture}
                            style={{ width: 48, height: 48, borderRadius: 78 }}
                          />
                        </View>
                      )}

                      <View style={{ width: "80%" }}>
                        <View
                          style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            paddingBottom: 10,
                          }}
                        >
                          <Text style={AppFontStyle.MEDIUM_ANYBODY_14}>
                            {message?.members
                              .filter((member) => member !== userData?.username)
                              .join(", ")}
                          </Text>
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 10,
                            }}
                          >
                            <Text style={AppFontStyle.REGULAR_ANYBODY_10}>
                              {getRelativeTime(message?.lastMessageTimestamp || 0)}
                            </Text>
                            <TouchableOpacity
                              onPress={() =>
                                removeMessage(message?.conversationId)
                              }
                            >
                              <Image
                                source={AppImages.icCloseWhiteSvg}
                                style={{
                                  height: 16,
                                  width: 16,
                                }}
                              />
                            </TouchableOpacity>
                          </View>
                        </View>
                        <Text style={AppFontStyle.MEDIUM_ANYBODY_12}>
                          {message?.lastMessage}
                        </Text>
                      </View>
                    </View>
                    <Separator
                      color={'#374151'}
                      height={1}
                      marginTop={12}
                      marginBottom={12}
                      marginHorizontal={0}
                    />
                  </TouchableOpacity>
                </View>
              ))
            ) : (
              <View style={{ padding: 40, alignItems: "center" }}>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_14,
                    {
                      color: AppColors.white,
                      textAlign: "center",
                    },
                  ]}
                >
                  No unread messages
                </Text>
              </View>
            )}
          </View>

          <TouchableOpacity
            onPress={() => {
              navigation.dispatch(
                CommonActions.reset({
                  index: 0,
                  routes: [{ name: "ChatTabStack" }],
                })
              );
              onClose();
            }}
          >
            <Text
              style={[AppFontStyle.BOLD_ANYBODY_18, { textAlign: "center" }]}
            >
              View All
            </Text>
          </TouchableOpacity>
            </>
          )}
        </View>
      </View>
    </Modal>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    modalOverlay: {
      flex: 1,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    overlayBackground: {
      position: "absolute",
      width: "100%",
      height: "100%",
    },
    modalContent: {
      backgroundColor: '#111827',
      padding: 12,
      borderRadius: 12,
      elevation: 5,
      borderWidth: 1,
      borderColor: '#374151',
      shadowColor: 'rgba(0, 0, 0, 0.10)',
      shadowOffset: { width: 0, height: 8 },
      shadowOpacity: 1,
      shadowRadius: 10,
    },
    tabContainer: {
      flexDirection: "row",

      gap: 20,
    },
    tab: {
      // flex: 1,
      alignItems: "center",
      paddingVertical: 6,
      paddingHorizontal: 8,
      borderWidth: 2,
      borderRadius: 57,
      // borderBottomColor: "transparent",
    },
    activeTab: {
      borderColor: AppColors.white,
    },
    inactiveTab: {
      borderColor: AppColors.gray_828282,
    },
    activeTabText: {
      color: AppColors.white,
    },
    inactiveTabText: {
      color: AppColors.gray_828282,
    },
  },
  {
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.SM]: {},
    [DEVICE_SIZES.XS]: {},
  }
);

export default MessagePopup;
